import { render, staticRenderFns } from "./FlightSchoolCriteria.vue?vue&type=template&id=10fb4cc6"
import script from "./FlightSchoolCriteria.vue?vue&type=script&lang=js"
export * from "./FlightSchoolCriteria.vue?vue&type=script&lang=js"
import style0 from "./FlightSchoolCriteria.vue?vue&type=style&index=0&id=10fb4cc6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports